import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { BotHeadSpin, OverlayPanel, Page } from '../../../../Components'
import HomeownerReportVideoSection from '../../../../Components/homeowners/HomeownerReportVideoSection'
import NewHomeWizard from '../../../../Components/homeowners/NewHomeWizard'
import { HomeownerReportTeaser } from '../../../../Components/shared/Teasers/HomeownerReportTeaser'
import { OVERLAY_HELPERS } from '../../../../constants/navigation'
import { selectClientHasHomes, selectClientIsLoadingData } from '../../../../store/selectors/client'

import styles from './NewHome.module.scss'

export const NewHome = () => {
  const intl = useIntl()
  const hasHomes = useSelector(selectClientHasHomes)
  const loading = useSelector(selectClientIsLoadingData)

  return (
    <OverlayPanel
      className={styles.root}
      path={OVERLAY_HELPERS.addHome.buildPath()}
      title={OVERLAY_HELPERS.getTitle('addHome', intl.formatMessage)}
      anchorOffset={250}
      render={() => (
        <Page>
          {loading && <BotHeadSpin panelSpacing />}
          {!loading && (
            <>
              <NewHomeWizard />
              {!hasHomes && (
                <>
                  <HomeownerReportTeaser />
                  <HomeownerReportVideoSection />
                </>
              )}
            </>
          )}
        </Page>
      )}
    />
  )
}
